<template>
  <app-modal
    :modal-id="modalId"
    modal-alignment="top"
    modal-size="fullscreen"
    @close-modal="closeModal"
  >
    <template slot="header">
      <h5 class="modal-title">{{ $t("New Job") }}</h5>
      <button
        type="button"
        class="close outline-none"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span>
          <app-icon :name="'x'"></app-icon>
        </span>
      </button>
    </template>
    <template slot="body">
      <div class="card card-with-search border-0 card-with-shadow">
        <div class="text-justify">
          <app-tab :tabs="tabsHorizontal" type="horizontal" />
        </div>
      </div>
      <!-- <div class="row">
        <dynamic-form-preview v-bind:Id="jobId"></dynamic-form-preview>
      </div> -->
    </template>

    <template slot="footer">
      <button
        type="button"
        class="btn btn-secondary mr-2"
        data-dismiss="modal"
        @click="closeModal"
      >
        {{ $t("close") }}
      </button>
      <!-- <button
        type="button"
        class="btn btn-primary mr-2"
        data-dismiss="modal"
        @click="submit"
      >
        {{ $t("update") }}
      </button> -->
    </template>
  </app-modal>
</template>

<script>
import { ModalMixin } from "../../../../../Mixins/ModalMixin";

export default {
  name: "FormBuilderModal",
  mixins: [ModalMixin],
  props: {
    jobId: Number,
  },
  data() {
    return {
      preloader: false,
      inputs: {
        yes: "no",
      },
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
      tabsHorizontal: [
        {
          icon: "info",
          name: "Job Detail",
          component: "job-view-detail",
          permission: "",
          props: { id: this.jobId },
        },
        {
          icon: "link",
          name: "Bid Form",
          component: "job-bid-form",
          permission: "",
          props: { id: this.jobId },
        },
      ],
    };
  },
  created() {
    
    // this.modalTitle = this.$t("Form Builder");
    // this.preloader = true;
  },
  methods: {
    submit() {},
  },
  mounted() {
    $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
  },
};
</script>
